import { render, staticRenderFns } from "./SyncBuildingCustomerToAfasButton.vue?vue&type=template&id=79a06400"
import script from "./SyncBuildingCustomerToAfasButton.vue?vue&type=script&lang=ts"
export * from "./SyncBuildingCustomerToAfasButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports